export enum STEP_STATUS {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  PENDING = 'PENDING'
}

export enum ALLOCATION_STATUS {
  COMPLETED = 'COMPLETED',
  INPROGRESS = 'INPROGRESS',
  FAILED = 'FAILED'
}

export interface ExecutionStep {
  stepName: string;
  stepStatus: STEP_STATUS;
}

export interface FailureMeta {
  numberOfAgents: string;
  emiToBeAllocated: string;
  totalAgentCapacity: string;
  emiLeftForAllocation: string;
  reason: string;
}

export interface AllocationSummary {
  allocationCycle: string;
  configName: string;
  allocationInitiatedAt: string;
  allocationCompletedAt: string;
  allocationRunType: string;
  allocationStatus: ALLOCATION_STATUS | null;
  failureMeta: FailureMeta | null;
  executionData: ExecutionStep[];
}

interface RunMetrics {
  totalRequiredRuns: number;
  completed: number;
  pending: number;
  inProgress: number;
  failed: number;
  completionStatus: string;
}

export enum REUPLOAD_STATUS {
  INPROGRESS = 'INPROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED'
}

export interface ReUploadSummary {
  workflowName: string;
  status: REUPLOAD_STATUS;
  createdAt: string;
  updatedAt: string;
  runMetrics: RunMetrics;
}
